import React from 'react';
import { NavigationProvider, useNavigation } from './context/NavigationContext';
import { AppProvider, useApp } from './context/AppContext';
import { VendorProvider } from './context/VendorContext';
import { Screen } from './types';
import { BottomNav } from './components/ui/BottomNav';
import { VendorBottomNav } from './components/ui/VendorBottomNav';
// Import Screens
import { SplashScreen } from './screens/SplashScreen';
import { OnboardingScreen } from './screens/OnboardingScreen';
import { WelcomeScreen } from './screens/WelcomeScreen';
import { LoginScreen } from './screens/LoginScreen';
import { SignUpScreen } from './screens/SignUpScreen';
import { OTPScreen } from './screens/OTPScreen';
import { HomeScreen } from './screens/HomeScreen';
import { CategoriesScreen } from './screens/CategoriesScreen';
import { ProductListScreen } from './screens/ProductListScreen';
import { ProductDetailScreen } from './screens/ProductDetailScreen';
import { CartScreen } from './screens/CartScreen';
import { CheckoutScreen } from './screens/CheckoutScreen';
import { OrderConfirmScreen } from './screens/OrderConfirmScreen';
import { OrdersScreen } from './screens/OrdersScreen';
import { OrderDetailScreen } from './screens/OrderDetailScreen';
import { ProfileScreen } from './screens/ProfileScreen';
import { WishlistScreen } from './screens/WishlistScreen';
import { SearchScreen } from './screens/SearchScreen';
import { NotificationsScreen } from './screens/NotificationsScreen';
import { AddressBookScreen } from './screens/AddressBookScreen';
import { PaymentMethodsScreen } from './screens/PaymentMethodsScreen';
import { SettingsScreen } from './screens/SettingsScreen';
import { HelpCenterScreen } from './screens/HelpCenterScreen';
import { FlashDealsScreen } from './screens/FlashDealsScreen';
import { RecommendedScreen } from './screens/RecommendedScreen';
import { ForgotPasswordScreen } from './screens/ForgotPasswordScreen';
import { OrderTrackingScreen } from './screens/OrderTrackingScreen';
import { WriteReviewScreen } from './screens/WriteReviewScreen';
import { ReturnRequestScreen } from './screens/ReturnRequestScreen';
import { VendorStoreScreen } from './screens/VendorStoreScreen';
import { LiveChatScreen } from './screens/LiveChatScreen';
import { ProductSourcingScreen } from './screens/ProductSourcingScreen';
import { AddCardScreen } from './screens/AddCardScreen';
import { ChangePasswordScreen } from './screens/ChangePasswordScreen';
import { TwoFactorScreen } from './screens/TwoFactorScreen';
import { EditProfileScreen } from './screens/EditProfileScreen';
import { VendorDashboardScreen } from './screens/VendorDashboardScreen';
import { VendorOrdersScreen } from './screens/VendorOrdersScreen';
import { VendorProductsScreen } from './screens/VendorProductsScreen';
import { VendorAddProductScreen } from './screens/VendorAddProductScreen';
import { VendorAnalyticsScreen } from './screens/VendorAnalyticsScreen';
import { VendorWalletScreen } from './screens/VendorWalletScreen';
import { VendorMessagesScreen } from './screens/VendorMessagesScreen';
import { VendorShippingScreen } from './screens/VendorShippingScreen';
import { VendorReviewsScreen } from './screens/VendorReviewsScreen';
import { VendorStoreSettingsScreen } from './screens/VendorStoreSettingsScreen';
import { VendorSignupScreen } from './screens/VendorSignupScreen';
import { VendorVerifyScreen } from './screens/VendorVerifyScreen';
import { VendorProfileScreen } from './screens/VendorProfileScreen';
import { VendorKYCScreen } from './screens/VendorKYCScreen';
import { VendorKYCEditScreen } from './screens/VendorKYCEditScreen';
import { VendorDeliveryScreen } from './screens/VendorDeliveryScreen';
import { VendorDisputesScreen } from './screens/VendorDisputesScreen';
import { CustomerDashboardScreen } from './screens/CustomerDashboardScreen';
import { VendorKYCStatusScreen } from './screens/VendorKYCStatusScreen';
import { VendorOrderDetailScreen } from './screens/VendorOrderDetailScreen';
import { VendorDisputeDetailScreen } from './screens/VendorDisputeDetailScreen';
import { VendorTransactionsScreen } from './screens/VendorTransactionsScreen';
import { VendorWithdrawalScreen } from './screens/VendorWithdrawalScreen';
function AppContent() {
  const {
    currentScreen
  } = useNavigation();
  const {
    isVendorMode
  } = useApp();
  const renderScreen = () => {
    switch (currentScreen) {
      case Screen.SPLASH:
        return <SplashScreen data-id="element-0" />;
      case Screen.ONBOARDING:
        return <OnboardingScreen data-id="element-1" />;
      case Screen.WELCOME:
        return <WelcomeScreen data-id="element-2" />;
      case Screen.LOGIN:
        return <LoginScreen data-id="element-3" />;
      case Screen.SIGNUP:
        return <SignUpScreen data-id="element-4" />;
      case Screen.OTP:
        return <OTPScreen data-id="element-5" />;
      case Screen.HOME:
        return <HomeScreen data-id="element-6" />;
      case Screen.CATEGORIES:
        return <CategoriesScreen data-id="element-7" />;
      case Screen.PRODUCT_LIST:
        return <ProductListScreen data-id="element-8" />;
      case Screen.PRODUCT_DETAIL:
        return <ProductDetailScreen data-id="element-9" />;
      case Screen.CART:
        return <CartScreen data-id="element-10" />;
      case Screen.CHECKOUT:
        return <CheckoutScreen data-id="element-11" />;
      case Screen.ORDER_CONFIRM:
        return <OrderConfirmScreen data-id="element-12" />;
      case Screen.ORDERS:
        return <OrdersScreen data-id="element-13" />;
      case Screen.ORDER_DETAIL:
        return <OrderDetailScreen data-id="element-14" />;
      case Screen.ORDER_TRACKING:
        return <OrderTrackingScreen data-id="element-15" />;
      case Screen.WRITE_REVIEW:
        return <WriteReviewScreen data-id="element-16" />;
      case Screen.RETURN_REQUEST:
        return <ReturnRequestScreen data-id="element-17" />;
      case Screen.VENDOR_STORE:
        return <VendorStoreScreen data-id="element-18" />;
      case Screen.PROFILE:
        return <ProfileScreen data-id="element-19" />;
      case Screen.EDIT_PROFILE:
        return <EditProfileScreen data-id="element-20" />;
      case Screen.WISHLIST:
        return <WishlistScreen data-id="element-21" />;
      case Screen.SEARCH:
        return <SearchScreen data-id="element-22" />;
      case Screen.NOTIFICATIONS:
        return <NotificationsScreen data-id="element-23" />;
      case Screen.ADDRESS_BOOK:
        return <AddressBookScreen data-id="element-24" />;
      case Screen.PAYMENT_METHODS:
        return <PaymentMethodsScreen data-id="element-25" />;
      case Screen.ADD_CARD:
        return <AddCardScreen data-id="element-26" />;
      case Screen.SETTINGS:
        return <SettingsScreen data-id="element-27" />;
      case Screen.HELP_CENTER:
        return <HelpCenterScreen data-id="element-28" />;
      case Screen.LIVE_CHAT:
        return <LiveChatScreen data-id="element-29" />;
      case Screen.PRODUCT_SOURCING:
        return <ProductSourcingScreen data-id="element-30" />;
      case Screen.CHANGE_PASSWORD:
        return <ChangePasswordScreen data-id="element-31" />;
      case Screen.TWO_FACTOR:
        return <TwoFactorScreen data-id="element-32" />;
      case Screen.FLASH_DEALS:
        return <FlashDealsScreen data-id="element-33" />;
      case Screen.RECOMMENDED:
        return <RecommendedScreen data-id="element-34" />;
      case Screen.FORGOT_PASSWORD:
        return <ForgotPasswordScreen data-id="element-35" />;
      case Screen.VENDOR_DASHBOARD:
        return <VendorDashboardScreen data-id="element-36" />;
      case Screen.VENDOR_ORDERS:
        return <VendorOrdersScreen data-id="element-37" />;
      case Screen.VENDOR_PRODUCTS:
        return <VendorProductsScreen data-id="element-38" />;
      case Screen.VENDOR_ADD_PRODUCT:
        return <VendorAddProductScreen data-id="element-39" />;
      case Screen.VENDOR_EDIT_PRODUCT:
        return <VendorAddProductScreen data-id="element-40" />;
      case Screen.VENDOR_ANALYTICS:
        return <VendorAnalyticsScreen data-id="element-41" />;
      case Screen.VENDOR_WALLET:
        return <VendorWalletScreen data-id="element-42" />;
      case Screen.VENDOR_MESSAGES:
        return <VendorMessagesScreen data-id="element-43" />;
      case Screen.VENDOR_SHIPPING:
        return <VendorShippingScreen data-id="element-44" />;
      case Screen.VENDOR_REVIEWS:
        return <VendorReviewsScreen data-id="element-45" />;
      case Screen.VENDOR_STORE_SETTINGS:
        return <VendorStoreSettingsScreen data-id="element-46" />;
      case Screen.VENDOR_SIGNUP:
        return <VendorSignupScreen data-id="element-47" />;
      case Screen.VENDOR_VERIFY:
        return <VendorVerifyScreen data-id="element-48" />;
      case Screen.VENDOR_PROFILE:
        return <VendorProfileScreen data-id="element-49" />;
      case Screen.VENDOR_KYC:
        return <VendorKYCScreen data-id="element-50" />;
      case Screen.VENDOR_KYC_EDIT:
        return <VendorKYCEditScreen data-id="element-51" />;
      case Screen.VENDOR_DELIVERY:
        return <VendorDeliveryScreen data-id="element-52" />;
      case Screen.VENDOR_DISPUTES:
        return <VendorDisputesScreen data-id="element-53" />;
      case Screen.CUSTOMER_DASHBOARD:
        return <CustomerDashboardScreen data-id="element-54" />;
      case Screen.VENDOR_KYC_STATUS:
        return <VendorKYCStatusScreen data-id="element-55" />;
      case Screen.VENDOR_ORDER_DETAIL:
        return <VendorOrderDetailScreen data-id="element-56" />;
      case Screen.VENDOR_DISPUTE_DETAIL:
        return <VendorDisputeDetailScreen data-id="element-57" />;
      case Screen.VENDOR_TRANSACTIONS:
        return <VendorTransactionsScreen data-id="element-58" />;
      case Screen.VENDOR_WITHDRAWAL:
        return <VendorWithdrawalScreen data-id="element-59" />;
      default:
        return <SplashScreen data-id="element-60" />;
    }
  };
  const showBuyerBottomNav = [Screen.HOME, Screen.CATEGORIES, Screen.CART, Screen.ORDERS, Screen.PROFILE, Screen.CUSTOMER_DASHBOARD].includes(currentScreen);
  const showVendorBottomNav = [Screen.VENDOR_DASHBOARD, Screen.VENDOR_ORDERS, Screen.VENDOR_PRODUCTS, Screen.VENDOR_MESSAGES, Screen.VENDOR_PROFILE, Screen.VENDOR_STORE_SETTINGS].includes(currentScreen);
  return <div className="w-full min-h-screen bg-gray-900 flex justify-center items-center" data-id="element-61">
      {/* Mobile Device Container */}
      <div className="w-full max-w-[430px] h-[100dvh] bg-white relative overflow-hidden shadow-2xl sm:rounded-[2.5rem] sm:border-[8px] sm:border-gray-800 sm:h-[90vh]" data-id="element-62">
        <div className="h-full overflow-y-auto scrollbar-hide" data-id="element-63">
          {renderScreen()}
        </div>
        {!isVendorMode && showBuyerBottomNav && <BottomNav data-id="element-64" />}
        {isVendorMode && showVendorBottomNav && <VendorBottomNav data-id="element-65" />}
      </div>
    </div>;
}
export function App() {
  return <NavigationProvider data-id="element-66">
      <AppProvider data-id="element-67">
        <VendorProvider data-id="element-68">
          <AppContent data-id="element-69" />
        </VendorProvider>
      </AppProvider>
    </NavigationProvider>;
}